module.exports = __webpack_public_path__ + "static/media/monaco-bomb.65c51e4c.png";